import { system } from "styled-system";
import styled from "styled-components";
import Box from "../box";
import { isNumber } from "../../utils/type-util";
function makeUnits(value) {
  return isNumber(value) ? `repeat(${value}, 1fr)` : value;
}
const gridSystem = system({
  flow: {
    property: "gridAutoFlow"
  },
  columns: {
    property: "gridTemplateColumns",
    transform: makeUnits
  },
  rows: {
    property: "gridTemplateRows",
    transform: makeUnits
  },
  autoColumns: {
    property: "gridAutoColumns"
  },
  autoRows: {
    property: "gridAutoRows"
  },
  areas: {
    property: "gridTemplateAreas"
  }
});
export const Grid = styled(Box).withConfig({
  displayName: "grid__Grid",
  componentId: "sc-s4rnwa-0"
})(["display:grid;", ""], gridSystem);
Grid.defaultProps = {
  height: "auto",
  flow: "row",
  columns: 24
};
export default Grid;